export const SOFTLINE_API_HAFTRUECKLAESSE = '/v1/joposten/entities';

export const SOFTLINE_API_DEFINITION_HAFTRUECKLASS_QUERY =
  '/v1/definitions/haftruecklass-query';
export const SOFTLINE_API_DEFINITION_HAFTRUECKLASS_LIST =
  '/v1/definitions/haftruecklass-list';
